import { useEffect, useState } from "react";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import ShareSideComponent from "../../Reusable/SideBar/Share/ShareSideComponent.js";
import queryString from "query-string";
import CommentComponent from "./Comment/CommentSideComponent.js";
import SideBarContentHolder from "./SideBarContentHolder.js";
import ContributorsSideBar from "components/Reusable/SideBar/Contributors/ContributorsSideBar.tsx";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useParams } from "react-router-dom";
import { DeleteMailInnerComponent } from "../FilesActionGroup/DeleteMailAction.js";

import "./SideBar.scss";

const SideBar = ({ lightBoxView }) => {
  const { getSideBarContent, getSideBarViewLightBox } = useSideBar();
  const { getMailSecurity, getDeleteParam, setDeleteParam, getMailStatus } =
    useMail();
  const { mobileCondition } = useMediaQueries();
  const { getSideBarViewGrid, setSideBar } = useSideBar();
  const { getFileId } = useLightBox();
  const { getTextByKey } = useContent();

  const { anotherParam, deleteMailParams } = useParams();
  const [style, setStyle] = useState({ top: 100 });

  // if url has sideBar prop
  useEffect(() => {
    const searchParams = queryString.parse(window.location.search);
    if (searchParams.sb === "comments") {
      setSideBar(
        <SideBarContentHolder
          headerName={getTextByKey("sidebar-comment-header")}
          headerIcon={"comment-solid"}
        >
          <CommentComponent />
        </SideBarContentHolder>
      );
    }
    if (searchParams.sb === "share" && !getMailSecurity()?.isSharingDisabled) {
      setSideBar(
        <SideBarContentHolder
          headerName={getTextByKey("sidebar-share-header")}
          headerIcon={"comment-solid"}
        >
          <ShareSideComponent email={searchParams.email} />
        </SideBarContentHolder>
      );
    }
    if (searchParams.contributor) {
      setSideBar(
        <SideBarContentHolder
          headerName={getTextByKey("collaborate-sidebar-title")}
          headerIcon="collab"
        >
          <ContributorsSideBar />
        </SideBarContentHolder>
      );
    }
  }, []);

  // if its selfeRemovalLink
  useEffect(() => {
    if (anotherParam === "delete") {
      setDeleteParam(deleteMailParams);
    }
  }, [anotherParam]);

  useEffect(() => {
    if (getDeleteParam() && !getSideBarViewGrid()) {
      setSideBar(
        <SideBarContentHolder
          headerName={getTextByKey("sidebar-delete-mail-header")}
          headerIcon={"trash-solid-b"}
        >
          <DeleteMailInnerComponent />
        </SideBarContentHolder>
      );
    }
  }, [getDeleteParam()]);

  useEffect(() => {
    const newTop = document.querySelector(".show-white-header")
      ? document.querySelector(".show-white-header")?.offsetHeight
      : document.querySelector(".content-header")?.offsetHeight;
    const newHeight =
      window.innerHeight -
      newTop -
      (mobileCondition ? window.innerHeight / 5 : 0);
    setStyle(
      mobileCondition
        ? {
            top: newTop,
            paddingBottom: mobileCondition ? 25 : "",
          }
        : {
            top: newTop,
            height: newHeight,
            paddingBottom: mobileCondition ? 25 : "",
          }
    );
  }, [getSideBarContent()]);

  useEffect(() => {
    if (getSideBarContent()) {
      const headerPos = document
        .querySelector(".content-header")
        ?.getBoundingClientRect().top;
      headerPos > 0 && window.scrollBy(0, headerPos + 20);
    }
  }, [getSideBarContent()]);

  useEffect(() => {
    getSideBarContent() &&
      mobileCondition &&
      document.body.classList.add("stop-scroll");
    !getSideBarContent() &&
      !getFileId() &&
      document.body.classList.remove("stop-scroll");
  }, [getSideBarViewGrid(), getSideBarContent()]);

  return (
    <AnimationContainer
      animationOn={
        !lightBoxView ? getSideBarViewGrid() : getSideBarViewLightBox()
      }
      animationClassName="side-bar-animation"
    >
      <div
        className="side-bar-container"
        style={lightBoxView ? {} : style}
        onClick={(e) => e.stopPropagation()}
      >
        {getSideBarContent()}
      </div>
    </AnimationContainer>
  );
};

export default SideBar;
